<div class="empty-widget_no-data_wrapper">
    <div class="empty-widget_no-data_container">
        <div class="empty-widget_no-data_header">
            {{'components.widgets.empty-widget.info_title' | l10n}}
        </div>
        <div class="empty-widget_no-data_info">
            {{'components.widgets.empty-widget.info_text' | l10n}}
        </div>
    </div>
</div>
